import { render, staticRenderFns } from "./VisaOffer.vue?vue&type=template&id=0638a6e4&scoped=true&"
import script from "./VisaOffer.vue?vue&type=script&lang=js&"
export * from "./VisaOffer.vue?vue&type=script&lang=js&"
import style0 from "./VisaOffer.vue?vue&type=style&index=0&id=0638a6e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638a6e4",
  null
  
)

export default component.exports